import { FootnoteRegular } from '../text/Typography';

const getFormatPart = (
    parts: Intl.DateTimeFormatPart[],
    type: Intl.DateTimeFormatPartTypes,
): string => parts.find((part) => part.type === type)?.value ?? '';

export const LastUpdated = ({ dataUpdatedAt }: { dataUpdatedAt: number }) => {
    if (dataUpdatedAt === 0) return null;

    const date = new Date(dataUpdatedAt);
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timeParts = new Intl.DateTimeFormat(undefined, {
        hour: 'numeric',
        minute: '2-digit',
        timeZone,
        timeZoneName: 'short',
    }).formatToParts(date);

    const time = `${getFormatPart(timeParts, 'hour')}:${getFormatPart(timeParts, 'minute')}${getFormatPart(timeParts, 'dayPeriod').replace(/\s/g, '')}`;
    const timeZoneCode = getFormatPart(timeParts, 'timeZoneName');
    const day = date.toLocaleDateString(undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        timeZone,
    });
    const lastUpdatedLabel = [
        'Information last updated',
        time,
        timeZoneCode,
        day,
    ]
        .filter((part) => part.length > 0)
        .join(' ');

    return (
        <FootnoteRegular alignSelf="center" color="$gray900">
            {lastUpdatedLabel}
        </FootnoteRegular>
    );
};
